import { render, staticRenderFns } from "./gatherUploadBtn.vue?vue&type=template&id=596a4a2a&scoped=true"
import script from "./gatherUploadBtn.vue?vue&type=script&lang=js"
export * from "./gatherUploadBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596a4a2a",
  null
  
)

export default component.exports